/* eslint-disable no-unused-vars */
/*
 * Colletion of /general functions that are used by other component related JS files
 */

function getMarkupSpriteIcon(symbolName, additionalClasses = '') {
  const msdConfig = window.msd_config || undefined;
  let iconSpriteUrl = '';
  if (msdConfig !== undefined) {
    iconSpriteUrl = msdConfig.iconSprite || '';
  }

  return `<span class="svg-icon ${additionalClasses}">
      <svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <use xlink:href="${iconSpriteUrl}#svg-symbol_${symbolName}"></use>
      </svg>
    </span>`;
}

/**
 * @typedef {Object} Coordinates Start and end position of element
 * @property {number} top - Top position of element
 * @property {number} bottom - Bottom position of element
 */

/**
 * Calculates the position of an element on the page.
 * @param {?HTMLElement} $scrollToElement
 * @returns {Coordinates}
 */
function calcScrollHeight($scrollToElement) {
  if (!($scrollToElement instanceof HTMLElement)) return { top: 0, bottom: 0 };

  return {
    top: $scrollToElement.getBoundingClientRect().top + document.documentElement.scrollTop,
    bottom: $scrollToElement.getBoundingClientRect().bottom + document.documentElement.scrollTop,
  };
}

/**
 * Scrolls to an element with an optional delay.
 * @param {?HTMLElement} $scrollToElement
 * @param {int} [delayInMs=0] - delay in ms
 * @param {'top'|'bottom'} [position='top'] - position to scroll to, stop at top or bottom of the element
 */
function scrollToElement($scrollToElement, delayInMs, position) {
  const delay = delayInMs || 0;
  const pos = position || 'top';

  if (!($scrollToElement instanceof HTMLElement)) return;

  const $mainMenu = document.getElementById('header');

  let menuHeight = 0;
  if ($mainMenu instanceof HTMLElement) {
    menuHeight = $mainMenu.getBoundingClientRect().height;
  }

  window.setTimeout(() => {
    const coordinates = calcScrollHeight($scrollToElement);
    let scrollHeight = coordinates.top;
    if( pos === 'bottom') {
      scrollHeight = coordinates.bottom;
    }

    window.scrollTo({ top: Math.max(0, scrollHeight - menuHeight), behavior: 'smooth' });
  }, delay);
}

/**
 * Scrolls to a position on the page with an optional delay.
 * @param {int} $pos
 * @param {int} [delayInMs=0] - delay in ms
 */
function scrollToPosition(pos, delayInMs) {
  const delay = delayInMs || 0;

  const $mainMenu = document.getElementById('header');

  let menuHeight = 0;
  if ($mainMenu instanceof HTMLElement) {
    menuHeight = $mainMenu.getBoundingClientRect().height;
  }

  window.setTimeout(() => {
    window.scrollTo({ top: Math.max(0, pos - menuHeight), behavior: 'smooth' });
  }, delay);
}

/**
 * Throttles a callback function in execution.
 * @param {Function} func function to throttle
 * @param {int} timeFrame time in ms
 */
function throttle(func, timeFrame) {
  var lastTime = 0;
  return function(...args) {
    var now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}

/**
 * Checks if is a internal or external url/link.
 * @param {string} url - url of link element
 * @returns {(undefined|boolean)} Will return `undefined` if neither "internal" nor "external" link could be identified
 */
function isInternalURL(url = '') {
  let isInternalLink;
  const hostname = window.location.hostname;

  // Match if the url starts with "/", "./", "../" or "#" to identify as interal link
  const regex = /^(\/|.\/|..\/|#)/;

  // anchor / jumpmark considered as internal link
  if (regex.test(url.trim())) return true;

  if (url !== '') {
    try {
      const urlInstance = new URL(url);

      if (hostname) {
        isInternalLink = new RegExp(hostname, 'i').test(urlInstance.hostname);
      }
    } catch (error) {
      // issue while checking the hostname (e.g. invalid url provided)
    }
  }

  return isInternalLink;
}

export {
  getMarkupSpriteIcon,
  calcScrollHeight,
  scrollToElement,
  scrollToPosition,
  throttle,
  isInternalURL,
};
